module.exports = __webpack_public_path__ + "img/delete.502d235f.svg";